import { fileUrl } from "@/lib/api";

const sizes = { sm: "w-8 h-8 text-xs", md: "w-11 h-11 text-sm", lg: "w-20 h-20 text-xl" };
const dotSizes = { sm: "w-2.5 h-2.5", md: "w-3 h-3", lg: "w-4 h-4" };

export const Avatar = ({ path, name = "", size = "md", className = "", online }) => {
  const url = fileUrl(path);
  const initials = (name || "?")
    .split(" ")
    .map((w) => w[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

  return (
    <div className={`relative shrink-0 ${className}`}>
      <div
        className={`${sizes[size]} rounded-full overflow-hidden flex items-center justify-center bg-gradient-to-br from-cyan-500/30 to-purple-600/30 border border-white/15 text-white font-bold`}
      >
        {url ? (
          <img src={url} alt={name} className="w-full h-full object-cover" />
        ) : (
          <span>{initials}</span>
        )}
      </div>
      {online !== undefined && (
        <span
          title={online ? "Online now" : "Offline"}
          className={`absolute -bottom-0 -right-0 ${dotSizes[size]} rounded-full border-2 border-black ${
            online ? "bg-green-400 shadow-[0_0_8px_rgba(74,222,128,0.8)]" : "bg-slate-600"
          }`}
        />
      )}
    </div>
  );
};
